import { createLogger } from "$/utils/logger";

export const spectrogramLogger = createLogger("Sepectrogram");
